/* eslint-disable no-underscore-dangle */
import React from 'react'
import classNames from 'classnames'
import dayjs, { Dayjs } from 'dayjs'
import { CalendarProps } from 'src/antd'
import { css } from 'styled-components'

import { gray600 } from 'src/styles/color-theme'

import { Typography } from './Typography'

/**
 * these styles are automatically added to storybook global styles so no need to add them manually on FE.
 * src/styles.tsx
 */
export const GetCalendarPropsGlobalStyles = css`
  .whf-ant-calendar-base {
    padding-left: 32px;

    .ant-picker-week-number {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      margin-left: -28px;
      width: 24px;
      height: 24px;
      cursor: default;
      pointer-events: none;
    }
  }
`

const today = dayjs()

export const getCalendarProps = ({
  className,
  dateCellRender,
  fullscreen,
}: Pick<
  CalendarProps<Dayjs>,
  'className' | 'dateCellRender' | 'fullscreen'
>): Pick<CalendarProps<Dayjs>, 'dateFullCellRender' | 'className'> => {
  const firstDayOfWeek = dayjs().localeData().firstDayOfWeek()
  return {
    dateFullCellRender: (current) => {
      return (
        <>
          {current.day() === firstDayOfWeek && (
            <div className="ant-picker-week-number">
              <Typography style={{ color: gray600 }}>
                {dayjs(current).endOf('week').isoWeek()}
              </Typography>
            </div>
          )}
          <div
            className={classNames(
              `ant-picker-cell-inner`,
              `ant-picker-calendar-date`,
              {
                [`ant-picker-calendar-date-today`]: dayjs(current).isSame(
                  today,
                  'd'
                ),
              }
            )}
          >
            <div className="ant-picker-calendar-date-value">
              {dayjs(current).date()}
            </div>
            <div className="ant-picker-calendar-date-content">
              {fullscreen && dateCellRender && dateCellRender(current)}
            </div>
          </div>
        </>
      )
    },
    className: classNames(className, 'whf-ant-calendar-base'),
  }
}
